export default __webpack_public_path__ + "38097579f4d771eb064fea0d19d1cb36.webp";